module.exports = __webpack_public_path__ + "assets/img/player.fec13853.jpg";